<template>
  <v-app>
    <DialogHelpCenter />
    <v-container class="pa-0">
      <v-row class="ma-0">
        <v-col class="col-12">
          <v-row class="ma-0">
            <v-col
              class="col-12 col-md-8 px-0"
              :class="{
                'mb-4': $vuetify.breakpoint.smAndDown,
                'mb-0': $vuetify.breakpoint.mdAndUp,
              }"
            >
              <h2 class="pl-3">Pesquisar Profissionais</h2>
              <div class="block-search align-center justify-center d-flex">
                <article class="cap-opacity"></article>
                <v-row class="justify-center">
                  <v-col class="col-10 col-md-6 text-center">
                    <v-text-field
                      solo
                      hide-details
                      prepend-inner-icon="search"
                      label="Procure o nome do psicólogo."
                      class="input-search"
                      v-model="searchName"
                      @keyup.enter="searchPsychologists()"
                    ></v-text-field>
                    <v-btn
                      class="mt-2"
                      color="secondary"
                      large
                      @click="searchPsychologists()"
                      >PESQUISAR</v-btn
                    >
                  </v-col>
                </v-row>
              </div>
            </v-col>

            <v-col
              class="col-12 col-md-4"
              :class="{
                'mb-4': $vuetify.breakpoint.smAndDown,
                'mb-0': $vuetify.breakpoint.mdAndUp,
              }"
            >
              <h2>Próximas Consultas</h2>
              <v-row>
                <v-col
                  class="col-12 mt-4"
                  v-for="(item, index) in consultation"
                  :key="index"
                  :v-if="consultation.length != 0"
                >
                  <v-divider></v-divider>
                  <router-link
                    tag="div"
                    style="cursor: pointer"
                    class="my-list"
                    :to="{
                      name: 'DetalheConsultaPaciente',
                      params: { id: item.id },
                    }"
                  >
                    <p class="ma-0">{{ item.psychologist.name }}</p>
                    <span class="date ma-2 align-end d-flex">
                      <v-icon color="primary">date_range</v-icon>
                      <p class="mb-0 ml-2">{{ item.date | formatDate }}</p>
                    </span>
                    <span class="time ma-2 align-end d-flex">
                      <v-icon color="primary">access_time</v-icon>
                      <p class="mb-0 ml-2">
                        {{ item.time | formatDateTZ(item.date, item.time) }}
                      </p>
                    </span>
                  </router-link>
                </v-col>
                <v-col class="col-12 mt-4">
                  <div
                    class="no-schedule pa-3"
                    v-if="consultation.length === 0"
                  >
                    <v-icon
                      x-large
                      color="gray"
                      style="font-size: 80px; padding-bottom: 10px"
                      >sentiment_very_dissatisfied</v-icon
                    >
                    <p
                      class="subtitle-1"
                      style="color: #6f6f6f; font-weight: bold"
                    >
                      Você não tem compromissos futuros.
                    </p>
                  </div>
                </v-col>
              </v-row>
              <h2>Consulta com Terapeuta Chefe</h2>

              <v-row class="justify-center">
                <v-col class="col-10">
                  <div
                    class="caixa-primeira-consulta pa-3 d-flex flex-column align-center justify-space-between"
                  >
                    <div class="d-flex flex-column align-center justify-center">
                      <v-icon size="70" class="primary--text mr-2">help</v-icon>
                      <p class="ma-0 lato-bold gray--text text-center f-1">
                        Tem dúvidas sobre como escolher o profissional correto?
                        Precisa de alguma informação técnica que não encontrou
                        no nosso FAC? Agende uma consulta com a nossa Terapeuta
                        Chefe para que ela o oriente!
                      </p>
                    </div>
                    <v-btn
                      :to="chief_therapist_route"
                      class="mt-3 px-5 rounded-lg f-1"
                      color="secondary"
                      >Saiba Mais</v-btn
                    >
                  </div>
                </v-col>
              </v-row>

              <v-row>
                <v-col class="col-12">
                  <!-- <router-link tag="div" style="cursor: pointer;" class="my-list"> -->
                  <div
                    v-for="(item, index) in therapistConsultation"
                    :key="index"
                    class="my-list lightGreen pa-3"
                    style="cursor: pointer"
                    @click="goToDetalheConsulta(item)"
                  >
                    <p class="ma-0 secondary--text font-weight-bold">
                      {{ item.psychologist.name }}
                    </p>
                    <span class="date ma-2 align-end d-flex">
                      <v-icon color="primary">date_range</v-icon>
                      <p class="mb-0 ml-2">
                        {{ moment(item.date).format('DD/MM') }}
                      </p>
                    </span>
                    <span class="time ma-2 align-end d-flex">
                      <v-icon color="primary">access_time</v-icon>
                      <p class="mb-0 ml-2">
                        {{ item.time | formatDateTZ(item.date, item.time) }}
                      </p>
                    </span>
                  </div>
                  <div
                    class="d-flex flex-row align-center justify-center lightGreen pa-3 mt-3"
                    style="cursor: pointer"
                    v-if="therapistConsultation.length > 0"
                  >
                    <div>
                      <v-icon color="secondary" size="40" class="mr-3"
                        >done</v-icon
                      >
                    </div>
                    <div>
                      <p class="ma-0 gray--text font-weight-bold">
                        Agendamento realizado com sucesso.
                      </p>
                    </div>
                  </div>
                  <!-- </router-link> -->
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
        <v-col class="col-12 py-3">
          <div>
            <h2 class="text-center">Profissionais em Destaque</h2>
            <v-container class="pa-0">
              <v-row>
                <v-col
                  class="col-12 col-sm-6 col-md-3"
                  v-for="user in users"
                  :key="user.id"
                >
                  <CardPsy
                    :name="user.name"
                    :img="user.photo"
                    :slug="user.slug"
                  />
                </v-col>
              </v-row>
            </v-container>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <v-footer class="pa-0 footer">
      <v-row class="justify-center ma-0">
        <v-col
          class="primary py-3 text-center white--text col-12 d-flex justify-space-around align-center footer"
          style="font-size: 12px"
        >
          <div></div>
          <div class="description">
            <strong>RESPONSÁVEL TÉCNICO</strong> Inês Mata CRP/03: 9904. OPP: CP
            23204
          </div>
          <v-btn to="/paciente/faq" class="btn-faq">Faq</v-btn>
        </v-col>
      </v-row>
    </v-footer>
    <PopUp ref="popUp" :cardItem="cardItem" @ok="onInput" />
  </v-app>
</template>

<script>
import moment from 'moment';
import CardPsy from '../../components/CardPsy';
import DialogHelpCenter from '@/components/DialogHelpCenter.vue';
import Api from '../../services/httpClient';
import generalService from '../../services/general';
import PopUp from '../../components/PupUP.vue';
import getLanguage from '../../utils/getLanguage';

export default {
  components: {
    CardPsy,
    PopUp,
    DialogHelpCenter,
  },

  data: () => ({
    cod: '',
    chief_therapist_route: '',
    users: [],
    consultation: [],
    therapistConsultation: [],
    searchName: '',
    isConsultation: Boolean,
    firstAppointments: false,
    cardItem: [],
  }),

  async created() {
    await this.getPsiSpotlight();
    await this.getCod();
    await this.allConsultation();
    await this.verifyTherapistAppointments(this.cod);
    const language = getLanguage(window.location.href);
    if (language === 'pt-BR') {
      this.chief_therapist_route = `/paciente/profile-terapeuta/${process.env.VUE_APP_CHIEF_THERAPIST_BR}`;
    } else {
      this.chief_therapist_route = `/paciente/profile-terapeuta/${process.env.VUE_APP_CHIEF_THERAPIST_PT}`;
    }
  },
  mounted() {
    this.popUp();
  },
  methods: {
    popUp() {
      Api.get('/popups/')
        .then((res) => {
          console.log(res.data);
          const { data } = res;
          this.cardItem = data;
          if (this.cardItem.length === 0 || this.cardItem[0].active === false) {
            return;
          }
          const { popUp } = this.$refs;
          if (!popUp) return;
          popUp.openDialog();
        })
        .catch((err) => console.log(err));
    },

    async verifyTherapistAppointments() {
      const res = await generalService.getFirstAppointments();
      if (res.data === '') {
        this.firstAppointments = null;
      } else {
        this.firstAppointments = true;
      }
    },
    goToDetalheConsulta(consulta) {
      this.$router.push({
        name: 'DetalheConsultaPaciente',
        params: { id: consulta.id },
      });
    },
    getCod() {
      this.cod = localStorage.getItem('user-id');
    },
    getPsiSpotlight() {
      Api.get(`/psychologists/?is_featured=true`, {
        headers: {
          Authorization: `Token ${localStorage.getItem('user-token')}`,
        },
      }).then((response) => {
        // console.log(response.data.results);
        this.users = response.data.results;
      });
    },
    async allConsultation() {
      // this.isLoading = true;
      const date = moment().format('YYYY-MM-DD 00:00');
      try {
        const { data, status } = await Api.get(
          `/patients/${this.cod}/appointments/`,
          {
            params: {
              after_date_time: date,
              limit: '4',
              with_chief_therapist: true,
              status: 'SCHEDULED',
            },
          },
        );
        if (status === 200) {
          if (data.length !== 0) {
            // this.consultation = data;

            // eslint-disable-next-line no-restricted-syntax
            for (const appointment of data) {
              if (appointment.with_chief_therapist) {
                this.therapistConsultation.push(appointment);
              } else {
                this.consultation.push(appointment);
              }
            }
            console.log(this.consultation);
            console.log(
              'this.therapistConsultation ',
              this.therapistConsultation,
            );
            this.isConsultation = true;
          } else {
            this.isConsultation = false;
          }
        }

        // if (data.results.length != 0) {
        //   for (let index = 0; index < 5; index++) {
        //     this.consultation.push(data.results[index]);
        //   }
        //   // this.isConsultation = true;
        // }
      } catch (error) {
        console.log(error.response.data.detail);
      } finally {
        // this.isLoading = false;
      }
    },
    async searchPsychologists() {
      this.$router.push({
        name: 'BuscaPaciente',
        params: { name: this.searchName },
      });
    },
    moment,
  },
};
</script>

<style lang="css" scoped>
.footer {
  position: sticky;
  top: 100%;
}
h2 {
  color: var(--v-primary-base);
}

.block-search {
  background-image: url('../../assets/bg_dashboard.png');
  min-height: 360px;
  background-repeat: no-repeat;
  position: relative;
  background-position: center;
  background-size: contain;
}
.cap-opacity {
  position: absolute;
  width: 100%;
  height: 100%;
  background: #fff;
  opacity: 0.6;
}

* >>> .input-search.v-text-field--solo > .v-input__control > .v-input__slot {
  border-radius: 12px;
}

.my-list {
  display: flex;
  flex-direction: row;
  align-items: center;
}

p {
  flex: 1;
}

.no-schedule {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  background: #02a55333;
  border-radius: 20px;
  border: 1px dashed #02a554;
}

.caixa-primeira-consulta {
  border: 1px solid #93291e;
  background-color: #93291e0f;
  border-style: dashed;
  border-radius: 15px;
}

/* funcionad de MD para baixo */
@media (max-width: 768px) {
  .block-search {
    background-size: cover;
  }
  .flex-md-row-reverse {
    -ms-flex-direction: row-reverse !important;
    flex-direction: row-reverse !important;
  }
  .flex-md-column-reverse {
    -ms-flex-direction: column-reverse !important;
    flex-direction: column-reverse !important;
  }
  .footer {
    display: flex;
    flex-direction: column;
  }
  .description {
    max-width: 220px;
  }
}
.btn-faq {
  width: 110px;
  height: 35px;
  color: #93291e;
}
</style>
